module.exports = __webpack_public_path__ + "static/media/bat-direction-msg.44be089c.svg";